<template>
  <div :class="['slide-section', wrapperClasses]">
    <h5 :class="['content-link', toggleTextClasses, shouldOpen ? 'open' : 'closed']"
        @click="$emit('onToggleTextClick')">
      {{toggleText}}
    </h5>
    <div :class="['slide-section__slider', sliderClasses, shouldOpen ? 'slide-down' : 'slide-up']">
      <slot name="mainContent"></slot>
      <slot name="extraContent"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ToggleSectionSlide',
    props: {
      shouldOpen: Boolean,
      showToggleText: Boolean,
      sliderClasses: String,
      toggleText: String,
      toggleTextClasses: String,
      wrapperClasses: String
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.slide-section
  &__slider
    overflow: auto
    transition: all 0.5s ease

    &.slide-up
      max-height: 0
      overflow-y: hidden
      visibility: hidden

    &.slide-down
      max-height: 100%
      overflow-y: hidden
      visibility: visible

  .content-link
    color: $primary-color
    cursor: pointer
    font-family: "AileronLight"
    font-size: 1.5rem
    margin-bottom: .5rem

    &:before
      content: "+ "
      font-size: 1.25rem

    &:hover
      color: $tertiary-color

    &.open

      &:before
        content: "- "

      &:hover
        color: $negative-hover

    &.backup-campaign__toggle-text
      font-size: 1.2rem
</style>